import { useState, useCallback } from "react";

export type ColorScheme = "default" | "blue" | "gray" | "green";

export interface UseDisplayOptionsResult {
  open: boolean;
  toggle: () => void;
  improveNames: boolean;
  setImproveNames: (value: boolean) => void;
  scheme: ColorScheme;
  setScheme: (scheme: ColorScheme) => void;
}

/**
 * Manages the “Display Options” pop-over state:
 *  - open/closed
 *  - improve column names toggle
 *  - colour scheme selection
 */
export function useDisplayOptions(
  initialImprove: boolean = false,
  initialScheme: ColorScheme = "default"
): UseDisplayOptionsResult {
  const [open, setOpen] = useState(false);
  const [improveNames, setImproveNames] = useState(initialImprove);
  const [scheme, setScheme] = useState<ColorScheme>(initialScheme);

  const toggle = useCallback(() => setOpen((o) => !o), []);

  return {
    open,
    toggle,
    improveNames,
    setImproveNames,
    scheme,
    setScheme,
  };
}
